export enum RealmscapesEnum {
  // GALLET = 'Gallet',
  // GHUR = 'Ghur',
  ANDTOR = 'Season 25’',
}

export const SUPPORTED_REALMSCAPES: RealmscapesEnum[] = [
  // RealmscapesEnum.GALLET,
  // RealmscapesEnum.GHUR,
  RealmscapesEnum.ANDTOR,
]
